module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Preface")]), _c('br'), _vm._v("The Power of Kindness")]), _vm._v(" "), _c('p', {
    staticClass: "Paragraph-Style-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "src": "image/3.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-DropCap-_FBM"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("I")]), _vm._v("t is a tragedy that in 2002 the mention of tragedy has itself become commonplace. So much has been said, so many flags waved since the heart of America was opened on September 11, 200l, that it seems almost opportunistic to mention it "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("yet")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("And yet the events of that day are the new backdrop against which all our deeds, beautiful and kind, heinous or destructive, will now be"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("si"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("lhouetted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("In such a world kindness is not a frill; it is a spiritual necessity. Indeed, where we once might have thought of random acts of kindness as charming, delightful, or even amusing, we cannot but see them now as the moment-by-moment, day-by-day acts of love that pierce the night sky with millions of pinpoints of light, the deed-by-deed creation of a world of hopeful possibilities—indeed"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(", of")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("love.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("For what we now know in the cells of ours souls—what we have always known, but often forget—is that every corner of our universe—and of our ourselves—is claimed by either goodness or ungoodness, by that which springs from love and gathers us all closer into the basket of life, or that which rises from unlove and makes our journey an arduous ordeal; and that for love to prevail we must practice it by teaspoonfuls, and bucketfuls and floods, in nanoseconds and minutes, week after week, for our enti"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("re lives. ")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("The practice of kindness is the daily, friendly, homely caring form of love. It is both humble—a schoolboy bringing his teacher a bouquet of dandelions—and exalted—a fireman giving his life to save someone else’s. Kindness is love with hands and hearts and minds. It is both whimsical—causing our faces to crack into a smile—and deeply touching—causing our eyes to shimmer with tears. And its miraculous nature is such that the more acts of kindness we offer, the more of them we have to give, for acts of kindness are always drawn from the endless wel"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("l of")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("love.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("Kindness is twice blessed. It blesses the one who gives it with a sense of his or her own capacity to love, and the person who receives it with a sense of the beneficence of the universe. Kindness heals us, because it reminds us of our oneness, allows us to see ourselves in one another’s eyes, to remember that eyes themselves are a miracle, that seeing is a gift, and that the other, no matter who he or she may be, is, in one way or another, a perfect reflection of"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ourselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("The power of kindness is immense. It is nothing less, really, than the power to change t"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("he world. ")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Signature"
  }, [_vm._v("Daphne R"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ose")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Kingma")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Devider-line-3"
  }, [_vm._v("————— • • • —————")]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("Fear grows out of the things we think; it lives in our minds. Compassion grows out of the things we are, and lives in our hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote_Author _idGenParaOverride-1"
  }, [_vm._v("—Barbara Garrison")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1da209","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomActsKindness-5.vue
// module id = 75
// module chunks = 0